import { render, staticRenderFns } from "./RechercheList.vue?vue&type=template&id=1672410e&"
import script from "./RechercheList.vue?vue&type=script&lang=js&"
export * from "./RechercheList.vue?vue&type=script&lang=js&"
import style0 from "./RechercheList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports